import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Simulation from "./pages/Simulation";
import AutoInsurance from "./pages/services/AutoInsurance";
import HealthPlans from "./pages/services/HealthPlans";
import AgriculturalInsurance from "./pages/services/AgriculturalInsurance";
import LifeInsurance from "./pages/services/LifeInsurance";
import PrivatePension from "./pages/services/PrivatePension";
import Consortium from "./pages/services/Consortium";
import HomeInsurance from "./pages/services/HomeInsurance";
import BusinessInsurance from "./pages/services/BusinessInsurance";
import BlogComingSoon from "./pages/BlogComingSoon";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./components/templates/ScrollToTop";
import WhatsAppButton from "./components/ui/WhatsAppButton";
// Importando FontAwesome
import "@fortawesome/fontawesome-free/css/all.min.css";

function App() {
  return (
    <Router>
      <WhatsAppButton />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="sobre" element={<About />} />
          <Route path="contato" element={<Contact />} />
          <Route path="simulacao" element={<Simulation />} />
          <Route path="auto" element={<AutoInsurance />} />
          <Route path="saude" element={<HealthPlans />} />
          <Route path="agricola" element={<AgriculturalInsurance />} />
          <Route path="vida" element={<LifeInsurance />} />
          <Route path="previdencia" element={<PrivatePension />} />
          <Route path="consorcio" element={<Consortium />} />
          <Route path="residencial" element={<HomeInsurance />} />
          <Route path="empresarial" element={<BusinessInsurance />} />
          <Route path="blog" element={<BlogComingSoon />} />
          <Route path="politica-privacidade" element={<PrivacyPolicy />} />

          {/* Outras rotas serão adicionadas aqui */}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
